import script from "./folderFileName.vue?vue&type=script&setup=true&lang=js"
export * from "./folderFileName.vue?vue&type=script&setup=true&lang=js"

import "./folderFileName.vue?vue&type=style&index=0&id=58cd91ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58cd91ee"]])

export default __exports__